import toastMsg from './toastMsg';
import { asyncSimpleModal } from './common';

/**
 * 엑셀 다운로드 api 요청 후 후처리
 * - 에러 메시지가 있을 경우, 에러메시지 노출.
 * - 에러 메시지가 없을 경우, 엑셀 다운로드 안내 모달 노출.
 * @param email - 로그인한 유저 email
 * @param errMsg
 */
function noticeExcelDownloadResult(email, errMsg = null) {
  if (errMsg) {
    toastMsg.error(errMsg);
  } else {
    asyncSimpleModal({
      type: 'success',
      title: '엑셀 파일 요청 완료',
      message: `${email}로 엑셀파일을 받을 수 있는 링크를 전송하였습니다. 파일 크기에 따라 이메일 발송이 몇 분 소요될 수 있습니다.`,
    });
  }
}

export default noticeExcelDownloadResult;
